const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8932 4.42028L4.29001 16.9555V16.9653L4.20369 17.1293C3.76584 17.9612 4.36592 18.96 5.31001 18.96H18.69C19.6341 18.96 20.2342 17.9612 19.7963 17.1293L13.1068 4.42028C12.6382 3.53371 11.3617 3.53362 10.8932 4.42028ZM9.56682 3.71973C10.5983 1.76676 13.4017 1.76676 14.4332 3.71973L14.4337 3.72067L21.1237 16.4307C22.0858 18.2587 20.7659 20.46 18.69 20.46H5.31001C3.30129 20.46 2.00042 18.399 2.79001 16.6093V16.5845L9.56682 3.71973ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/WarningTriangle.1187cea6391323242447fd18049b1777.svg";
export { ForwardRef as ReactComponent };